import i18n from '@/utils/i18n';
import React from 'react';
import { BaseActionSheet } from '@/components/base-action-sheet';
import { Button } from '@/components/button';
import { createStyles } from '@/contexts/theme-context';
import { Text, View } from 'react-native';
import { useLayoutContext } from '@/contexts/layout-context';

interface Props {
  onClose: () => void;
  onConfirm: () => void;
}

export const ClearAllAlertsConfirmationActionSheet: React.FC<Props> = ({
  onClose,
  onConfirm,
}) => {
  const [styles] = useStyles();
  const { isSmallLayout } = useLayoutContext();

  return (
    <BaseActionSheet
      contentStyle={
        isSmallLayout ? styles.contentStyleMobile : styles.contentStyle
      }
      isVisible
      modalHeaderStyle={styles.modalHeaderStyle}
      modalStyle={isSmallLayout ? null : styles.modalStyle}
      onClose={onClose}
      showCloseButton={false}
    >
      <Text style={isSmallLayout ? styles.sheetTitleMobile : styles.sheetTitle}>
        {i18n.t('insights_hub.clear_confirmation_sheet.title')}
      </Text>
      <Text style={styles.sheetBody}>
        {i18n.t('insights_hub.clear_confirmation_sheet.body')}
      </Text>
      <View
        style={
          isSmallLayout ? styles.buttonWrapperMobile : styles.buttonWrapper
        }
      >
        <Button
          onPress={onConfirm}
          style={styles.clearButton}
          trackingData={{
            name: 'insights_hub.clear_all_alerts_confirmation_action_sheet.confirm',
          }}
          type="primary"
        >
          {i18n.t('clear')}
        </Button>
        <Button
          onPress={onClose}
          trackingData={{
            name: 'insights_hub.clear_all_alerts_confirmation_action_sheet.cancel',
          }}
          type="tertiary"
        >
          {isSmallLayout ? i18n.t('back') : i18n.t('cancel')}
        </Button>
      </View>
    </BaseActionSheet>
  );
};

const useStyles = createStyles((theme) => ({
  buttonWrapper: {
    flexDirection: 'row-reverse',
    gap: 8,
    justifyContent: 'flex-start',
    marginTop: 16,
  },
  buttonWrapperMobile: {
    gap: 8,
    marginTop: 16,
  },
  clearButton: {
    backgroundColor: theme.sk.color.bg.button.error.primary.default,
    borderColor: theme.sk.color.bg.button.error.primary.default,
  },
  contentStyle: {
    // Override BaseActionSheet
    paddingTop: 24,
  },
  contentStyleMobile: {
    gap: 16,
  },
  modalHeaderStyle: {
    // Override BaseActionSheet
    padding: 0,
  },
  modalStyle: {
    maxWidth: 420,
  },
  sheetBody: {
    color: theme.sk.color.text.secondary,
    fontFamily: theme.fonts.primary,
    fontSize: 16,
    lineHeight: 24,
  },
  sheetTitle: {
    color: theme.sk.color.text.primary,
    fontFamily: theme.fonts.primaryBold,
    fontSize: 21,
    marginBottom: 8,
  },
  sheetTitleMobile: {
    color: theme.sk.color.text.primary,
    fontFamily: theme.fonts.primaryBold,
    fontSize: 25,
  },
}));
